/* tslint:disable */

declare var Object: any;
export interface SFBpjsTkSummaryReportInterface {
  "id"?: number;
}

export class SFBpjsTkSummaryReport implements SFBpjsTkSummaryReportInterface {
  "id": number;
  constructor(data?: SFBpjsTkSummaryReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFBpjsTkSummaryReport`.
   */
  public static getModelName() {
    return "SFBpjsTkSummaryReport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFBpjsTkSummaryReport for dynamic purposes.
  **/
  public static factory(data: SFBpjsTkSummaryReportInterface): SFBpjsTkSummaryReport{
    return new SFBpjsTkSummaryReport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFBpjsTkSummaryReport',
      plural: 'SFBpjsTkSummaryReports',
      path: 'SFBpjsTkSummaryReports',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFBpjsTkSummaryReport.ts